import { logInApi, logOutApi, refreshLoginApi, whoAmIApi } from "@/api/auth";
// import { whoAmIApi } from "@/api/users";

export default {
    namespaced: true,
    state: {
        user: null,
        // isAuth: localStorage.getItem("isAuth") === "true",
        jwt: null,
    },
    getters: {
        // /**
        //  * возвращает данные о статусе аутентификации
        //  * @param state - объект Состояние, хранит данные доступные для приложения
        //  * @returns {boolean}
        //  */
        // isAuthenticated: (state) => state.isAuth,
        /**
         * возвращает данные об аутентифицированном пользователе
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @returns {null}
         */
        stateUser: (state) => state.user,
        jwt: (state) => state.jwt,
    },
    mutations: {
        // /**
        //  * мутация, записывает статус аутентификации в хранилище
        //  * @param state - объект Состояние, хранит данные доступные для приложения
        //  * @param status - статус аутентификации
        //  * @constructor
        //  */
        // SET_AUTH(state, status) {
        //     state.isAuth = status;
        // },
        /**
         * мутация, записывает пользователя в хранилище
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @param user - объект с данными о пользователе
         * @constructor
         */
        SET_USER(state, user) {
            state.user = user;
        },
        /**
         * мутация, записывает JWT в хранилище
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @param jwt - объект с данными о токенах
         * @constructor
         */
        SET_JWT(state, jwt) {
            state.jwt = {
                jwt_token: jwt.jwt_token,
                // refresh_token: jwt.refresh_token,
            };
        },
        /**
         * мутация, сбрасывает JWT
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @constructor
         */
        RESET_JWT(state) {
            state.jwt = null;
        },
    },
    actions: {
        /**
         * функция глобального хранилища для вызова мутации (SET_AUTH), инициализирует вызов API (logInApi) и запрос на получение дополнительных сведениях об аутентифицированном пользователе
         * @param user - объект с данными о пользователе (логин, пароль)
         * @param dispatch - внутренняя функция для вызова action из store
         * @param commit - внутренняя функция для вызова мутации, изменение состояния глобальных объектов
         * @returns {Promise<void>} функция асинхронна, поэтому имеется возможность дождаться ее выполнения
         * @constructor
         */
        async LOGIN({ dispatch, commit }, user) {
            try {
                const jwt = await logInApi(user);
                // localStorage.setItem("isAuth", JSON.stringify(true));
                // для безопасности в localstorage записываем только refresh токен, текущий токен храним только в памяти
                // localStorage.setItem(
                //     "refresh",
                //     JSON.stringify(jwt?.refresh_token)
                // );
                await commit("SET_JWT", jwt);
                // await commit("SET_AUTH", true);
                await dispatch("WHOAMI");
            } catch (e) {
                await dispatch("LOGOUT");
            }
        },
        /**
         * функция глобального хранилища для вызова мутации (SET_USER), инициализирует вызов API (whoAmIApi)
         * @param dispatch - внутренняя функция для вызова action из store
         * @param commit - внутренняя функция для вызова мутации, изменение состояния глобальных объектов
         * @returns {Promise<void>}
         * @constructor
         */
        async WHOAMI({ commit, dispatch }) {
            try {
                let { content: user } = await whoAmIApi();
                await commit("SET_USER", user);
            } catch (e) {
                await dispatch("LOGOUT");
            }
        },
        /**
         * функция глобального хранилища, инициализирует вызов API (logOutApi) - вызывает мутацию для удаления всех данных о пользователе
         * @param commit - внутренняя функция для вызова мутации, изменение состояния глобальных объектов
         * @returns {Promise<void>}
         * @constructor
         */
        async LOGOUT({ commit }) {
            // localStorage.removeItem("isAuth");
            // localStorage.removeItem("refresh");
            await logOutApi();
            await commit("RESET_JWT");
            // commit("SET_AUTH", false);
            commit("SET_USER", null);
            // для поддержки выхода из системы во всех окнах
            localStorage.setItem("logout", Date.now());
        },
        /**
         * функция глобального хранилища для вызова мутации (SET_JWT), инициализирует вызов API (refreshLoginApi) и запрос на получение дополнительных сведениях об аутентифицированном пользователе
         * @param dispatch - внутренняя функция для вызова action из store
         * @param commit - внутренняя функция для вызова мутации, изменение состояния глобальных объектов
         * @returns {Promise<void>} функция асинхронна, поэтому имеется возможность дождаться ее выполнения
         * @constructor
         */
        async REFRESH_LOGIN({ dispatch, commit }) {
            try {
                const jwt = await refreshLoginApi();
                await commit("SET_JWT", jwt);
                await dispatch("WHOAMI");
            } catch (e) {
                // выбрасывает ошибку наверх, REFRESH_LOGIN вызывается в router BeforeEach, в случае ошибки происходит rendering на /login
                throw new Error(e);
            }
        },
        /**
         * вызывает мутацию для обновления данных об аутентифицированном пользователе
         * @param commit - внутренняя функция для вызова мутации, изменение состояния глобальных объектов
         * @param user объект с данными о пользователе
         * @returns {Promise<void>}
         * @constructor
         */
        async UPDATE_USER({ commit }, user) {
            commit("SET_USER", user);
        },
        /**
         * вызывает мутацию для сброса данных об аутентифицированном пользователе
         * @param commit - внутренняя функция для вызова мутации, изменение состояния глобальных объектов
         * @returns {Promise<void>}
         * @constructor
         */
        async RESET_USER({ commit }) {
            // commit("SET_AUTH", false);
            commit("SET_USER", null);
        },
    },
};
